import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';

import { MultiBaseAbstractApi } from '@api/genericApi/multi-base-abstract.api';
import { FolderApi } from './models/folder.api.model';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { DisplayGroupPatchModel } from '../displayGroups/models/display-group-patch.api.model';



@Injectable()
export class FoldersApiService extends MultiBaseAbstractApi<FolderApi, FolderApi> {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<FolderApi[]> {
        const slug = '/mentions/folders';
        return this.neptuneApi.api<FolderApi[]>(slug, null, HttpVerbsEnum.GET);
    }


    create(folder: FolderApi): Observable<number> {
        const slug = '/mentions/folders';

        const body = {
            name: folder.name,
            displayGroupId: folder.displayGroupId
        };

        return this.neptuneApi.api<number>(
            slug,
            body,
            HttpVerbsEnum.POST
        );
    }


    update(folder: FolderApi): Observable<null> {
        const slug = `/mentions/folders/${folder.id}`;

        return this.neptuneApi.api<null>(
            slug,
            folder,
            HttpVerbsEnum.PUT
        );
    }


    deleteById(id: number): Observable<null> {
        const slug = `/mentions/folders/${id}`;

        return this.neptuneApi.api<null>(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    updateFavorites(addIds: number[], removeIds: number[]) {
        const slug: string = '/mentions/folders/displaygroups/favorites';

        const patchModel: DisplayGroupPatchModel = {
            addResourceIds: addIds,
            removeResourceIds: removeIds
        };

        return this.neptuneApi.api<void>(
            slug,
            patchModel,
            HttpVerbsEnum.PATCH
        );
    }

    /**
     * Adds and/or removes folders to/from provided group
     * @param addIds Folders to add to group
     * @param removeIds Folders to remove from group
     * @param groupId
     */
    updateDisplayGroup(addIds: number[], removeIds: number[], groupId: number): Observable<void> {
        const slug: string = `/mentions/folders/displaygroups/${groupId}`;

        const patchModel: DisplayGroupPatchModel = {
            addResourceIds: addIds,
            removeResourceIds: removeIds
        };
        return this.neptuneApi.api<void>(
            slug,
            patchModel,
            HttpVerbsEnum.PATCH
        );
    }

    /**
     * Removes all group IDs from provided folders
     * @param removeIds folders to remove
     */
    removeDisplayGroup(removeIds: number[]): Observable<void> {
        const slug: string = '/mentions/folders/displaygroups';

        const patchModel: DisplayGroupPatchModel = {
            addResourceIds: [],
            removeResourceIds: removeIds
        };

        return this.neptuneApi.api<void>(
            slug,
            patchModel,
            HttpVerbsEnum.PATCH
        );
    }

    /** @deprecated not implemented */
    getById(id: number): Observable<FolderApi> {
        return throwError(() => new Error('Not implemented'));
    }
}
